import { gql } from '@apollo/client';

import { WidgetType } from '../../types/widget';

export const WIDGET_FIELDS = `
	id
	name
	type
	x
	y
	width
	height
	isAvailableOnDesktopFormat
	isAvailableOnMobileFormat
	configuration
`;

// QUERIES

export type FetchWidgetsType = {
	widgets: WidgetType[];
};

export const FETCH_WIDGETS = gql`
	query Widgets {
		widgets {
			${WIDGET_FIELDS}
		}
	}
`;
